import { getNavigationUrl } from '../../renderer/utils/subdomainUtils';

/** True on localhost / 127.0.0.1 so engineers can use the quick menu on desktop. */
export function isK9QuickMenuDevelopmentHost(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  const host = window.location.hostname;
  return host === 'localhost' || host === '127.0.0.1';
}

/**
 * Mobile, tablet, or touch + ≤1024px — devices that should see the APEX K9™ Quick Menu (k9.* PWA).
 */
export function isK9QuickMenuFieldDevice(): boolean {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }
  const userAgent = navigator.userAgent;
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
  const isTablet =
    /iPad|Android(?=.*Mobile)/i.test(userAgent) ||
    (navigator.maxTouchPoints > 2 && /MacIntel/.test(userAgent));
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  const isSmallScreen = window.innerWidth <= 1024;
  return isMobile || isTablet || (isTouchDevice && isSmallScreen);
}

export function shouldShowK9QuickMenu(): boolean {
  return isK9QuickMenuDevelopmentHost() || isK9QuickMenuFieldDevice();
}

/** Console dashboard on apex (e.g. k9.* desktop → https://americanpolicetraining.com/k9-ops/dashboard). */
export function getK9DesktopDashboardUrl(): string {
  return getNavigationUrl('/k9-ops/dashboard');
}

export function redirectDesktopToK9Dashboard(): void {
  if (typeof window === 'undefined') {
    return;
  }
  window.location.replace(getK9DesktopDashboardUrl());
}
